import React from 'react'
import { ActionButtonIcons, ActionButtons } from '@enamelai/design-system'
import { Icon as DeleteFilledIcon } from '@enamelai/design-system/icons/Delete2'

type SettingsRowActionsProps = {
  disabled?: boolean
  deleteDisabled?: boolean
  onView?: () => void
  onEdit: () => void
  onDelete: () => void
}

/** Optional view + edit + delete table actions; delete uses the filled icon like Patient Management. */
function SettingsRowActions({
  disabled = false,
  deleteDisabled = false,
  onView,
  onEdit,
  onDelete,
}: SettingsRowActionsProps): React.ReactElement {
  return (
    <ActionButtons
      size="sm"
      actions={[
        ...(onView
          ? [
              {
                id: 'view',
                label: 'View',
                icon: ActionButtonIcons.view(),
                tone: 'primary' as const,
                variant: 'solid' as const,
                size: 'sm' as const,
                disabled,
                onClick: onView,
              },
            ]
          : []),
        {
          id: 'edit',
          label: 'Edit',
          icon: ActionButtonIcons.edit(),
          tone: 'primary',
          variant: 'outline',
          size: 'sm',
          disabled,
          onClick: onEdit,
        },
        {
          id: 'delete',
          label: 'Delete',
          icon: (
            <DeleteFilledIcon
              className="ds-action-button__svg"
              aria-hidden="true"
            />
          ),
          tone: 'danger',
          variant: 'outline',
          size: 'sm',
          disabled: disabled || deleteDisabled,
          onClick: onDelete,
        },
      ]}
    />
  )
}

export default SettingsRowActions
